// © Microsoft Corporation. All rights reserved.

import { DesignSystem, neutralForegroundRest } from "@microsoft/fast-components-styles-msft";

import { applyLocalizedProperty } from "@microsoft/fast-jss-utilities";
import { enums } from "../../../../utils/enums";
import { neutralLayerCard } from "@microsoft/fast-components-styles-msft";

const padding = 19;
export const ProfilePrivacySuperAppStyles = (config: DesignSystem) => ({
    profilePrivacySuperAppContainer: {
        margin: "16px auto",
        "border-radius": "6px",
        padding: `${padding}px`,
        "max-width": "75vw",
        width: "75vw",
        background: neutralLayerCard,
        "box-shadow": "0px 0px 0.8px rgba(0, 0, 0, 0.13), 0px 2px 10px rgba(0, 0, 0, 0.08)",

        "& .cwt-private-switch": {
            display: "block",

            "& .cwt-switch-label": {
                margin: "0 0 15px 0",
                "font-weight": "500"
            },

            "& .cwt-switch": {
                [applyLocalizedProperty("margin-left", "margin-right", config.direction)]: "0"
            }
        },
        "& .cwt-h-seperator": {
            margin: `${padding}px -${padding}px`,
            background: "rgba(143, 158, 205, 0.2)"
        },

        ["&." + enums.responsiveLevels.L0]: {
            margin: "0",
            "box-shadow": "none",
            width: "auto",
            "max-width": "initial",
            background: "none",
            "border-radius": "0"
        }

    },

    profileDataSuperAppContainer: {
        "& .cwt-title": {
            "font-weight": "500"
        },

        "& .cwt-description": {
            color: neutralForegroundRest,
            margin: "16px 0"
        }
    }
});